import { ParameterCodeDataPolicy } from "constants/common/ParameterCodeDataPolicy";
import { EMPTY_TRANSFER_OF_CHARGE_BULK_EDIT_CRITERIA, TransferOfChargeBulkEditCriteria } from "domain/entity/TransferOfCharge/TransferOfChargeBulkEditCriteria";
import { TransferOfChargeEntity } from "domain/entity/TransferOfCharge/TransferOfChargeEntity";
import { EMPTY_TRANSFER_OF_CHARGE_SEARCH_CRITERIA, TransferOfChargeSearchCriteria } from "domain/entity/TransferOfCharge/TransferOfChargeSearchCriteria";
import { ChargeTypeRepository } from "domain/repository/ChargeType/ChargeTypeRepo";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { CounterCustomerChargeRepository } from "domain/repository/CounterCustomerCharge/CounterCustomerChargeRepo";
import { OpsLineRepository } from "domain/repository/OpsLine/OpsLineRepo";
import { ParameterDetailRepository } from "domain/repository/parameter/ParameterDetailRepo";
import { RequestServiceCodeRepository } from "domain/repository/RequestServiceCode/RequestServiceCodeRepo";
import { TransferOfChargeRepository } from "domain/repository/TransferOfCharge/TransferOfChargeRepo";
import _ from "lodash";
import { SaptTransferOfChargeSearchCriteriaValidationSchema, transferOfChargeSearchCriteriaValidationSchema } from "presentation/constant/TransferOfCharge/TransferOfChargeSearchCriteriaValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { DropdownProps } from "presentation/model/DropdownProps";
import { TransferOfChargeModel } from "presentation/model/TransferOfCharge/TransferOfChargeModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface TransferOfChargeVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<TransferOfChargeModel>> | ((value: SetStateAction<TransferOfChargeModel>) => void),
    ],
    transferOfChargeRepo: TransferOfChargeRepository,
    opsLineRepo: OpsLineRepository,
    companyRepo: CompanyRepository,
    chargeTypeRepo: ChargeTypeRepository,
    requestServiceCodeRepo: RequestServiceCodeRepository,
    parameterDetailRepo: ParameterDetailRepository,
    counterCustomerChargeRepo: CounterCustomerChargeRepository,
}

export const TransferOfChargeVM = ({ dispatch, transferOfChargeRepo,
    companyRepo, opsLineRepo, chargeTypeRepo, requestServiceCodeRepo, parameterDetailRepo, counterCustomerChargeRepo }: TransferOfChargeVMProps) => {
    const [transferOfChargeDispatch] = dispatch;

    const loadDropdownOption = async () => {

        await chargeTypeRepo.getAllChargeTypesForCombobox().then(
            chargeTypes => {
                let newChargeTypeList = _.orderBy(chargeTypes, ["chargeType", "subChargeType"]);
                //let newChargeTypes = newChargeTypeList.filter(entity => entity.chargeCategory === 'GEN' || entity.chargeCategory === 'SYS');

                let chargeTypeDropdownOption: DropdownProps[] = [];
                let subChargeTypeDropdownOption: { [key: string]: DropdownProps[] } = {};
                newChargeTypeList?.forEach(chgTypeEty => {
                    const chgTypeExisted = chargeTypeDropdownOption?.find(chgType =>
                        chgType.value === chgTypeEty.chargeType);
                    if (!chgTypeExisted) {
                        chargeTypeDropdownOption.push({
                            dropdownLabel: chgTypeEty.chargeType,
                            tagLabel: chgTypeEty.chargeType,
                            value: chgTypeEty.chargeType
                        })
                    }
                    if (chgTypeEty.subChargeType) {
                        if (!subChargeTypeDropdownOption[chgTypeEty.chargeType]) {
                            subChargeTypeDropdownOption[chgTypeEty.chargeType] = [];
                        }
                        subChargeTypeDropdownOption[chgTypeEty.chargeType].push({
                            dropdownLabel: chgTypeEty.subChargeType,
                            tagLabel: chgTypeEty.subChargeType,
                            value: chgTypeEty.subChargeType
                        });
                    }
                });

                transferOfChargeDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        chargeTypeDropdownOptions: chargeTypeDropdownOption,
                        subChargeTypeDropdownOptions: subChargeTypeDropdownOption
                    }
                }))
            }
        )

        await requestServiceCodeRepo.getEntities().then(
            reqServiceCodeList => {
                let reqServiceCodeDropdownOption: DropdownProps[] = [];
                let allSubReqServiceCodeDropdownOption: DropdownProps[] = [];
                let subReqServiceCodeDropdownOption: { [key: string]: DropdownProps[] } = {};

                let codeList = reqServiceCodeList.filter(entity => entity.activeInd === 'Y');
                codeList?.forEach(entity => {
                    const codeExisted = reqServiceCodeDropdownOption?.find(code =>
                        code.value === entity.serviceRequestCode);
                    if (!codeExisted) {
                        reqServiceCodeDropdownOption.push({
                            dropdownLabel: entity.serviceRequestCode ?? '',
                            tagLabel: entity.serviceRequestCode ?? '',
                            value: entity.serviceRequestCode ?? '',
                        })
                    }
                    const subCodeExisted = allSubReqServiceCodeDropdownOption?.find(code =>
                        code.value === entity.subServiceRequestCode);
                    if (!subCodeExisted) {
                        allSubReqServiceCodeDropdownOption.push({
                            dropdownLabel: entity.subServiceRequestCode ?? '',
                            tagLabel: entity.subServiceRequestCode ?? '',
                            value: entity.subServiceRequestCode ?? '',
                        })
                    }
                    if (entity.serviceRequestCode && entity.subServiceRequestCode) {
                        if (!subReqServiceCodeDropdownOption[entity.serviceRequestCode]) {
                            subReqServiceCodeDropdownOption[entity.serviceRequestCode] = [];
                        }
                        subReqServiceCodeDropdownOption[entity.serviceRequestCode].push({
                            dropdownLabel: entity.subServiceRequestCode,
                            tagLabel: entity.subServiceRequestCode,
                            value: entity.subServiceRequestCode
                        });
                    }
                });


                transferOfChargeDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        serviceRequestCodeDropdownOptions: reqServiceCodeDropdownOption,
                        subServiceRequestCodeDropdownOptions: subReqServiceCodeDropdownOption,
                        allSubReqServiceCodeDropdownOptions: allSubReqServiceCodeDropdownOption
                    }
                }))
            }
        )

        await opsLineRepo.getOpsLineForCombobox().then(
            opsLines => {
                const opsLinesDropdownOptions = opsLines?.map((opsLineEntity) => ({
                    dropdownLabel: opsLineEntity.opsLine,
                    tagLabel: opsLineEntity.opsLine,
                    value: opsLineEntity.opsLine,
                })) ?? []

                transferOfChargeDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        opsLineDropdownOptions: opsLinesDropdownOptions
                    }
                }))
            }
        )

        await companyRepo.getAllCompanyForCombobox().then(
            companies => {
                let companyCodeDropdownOptions = companies?.map((company) => ({
                    dropdownLabel: company.companyCode,
                    tagLabel: company.companyCode,
                    value: company.companyCode,
                })) ?? []
                companyCodeDropdownOptions = _.orderBy(companyCodeDropdownOptions, "dropdownLabel");

                transferOfChargeDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        billToCompanyDropdownOptions: companyCodeDropdownOptions,
                        chargeOnCompanyDropdownOptions: companyCodeDropdownOptions,
                    }
                }))
            }
        )

        await parameterDetailRepo.getAllParameterDtlsByParameterCode(ParameterCodeDataPolicy.ACCOUNT_TERMINAL_REASON_CODE).then(
            reasonCodeList => {
                const reasonCodeDropdownOptions = reasonCodeList?.map((ety) => ({
                    dropdownLabel: ety.parameterDtlCode,
                    tagLabel: ety.parameterDtlCode,
                    value: ety.parameterDtlCode,
                })) ?? []

                transferOfChargeDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        reasonCodeDropdownOptions: reasonCodeDropdownOptions
                    }
                }))
            }
        )

    }

    const updateSelectedRows = async (selecedRows: TransferOfChargeEntity[]) => {
        transferOfChargeDispatch(prevState => {
            const disableAccTmlResumeStateArr: string[] = ["I", "DI", "H", "MH", "C", "TOC"];
            const disableHoldUnHoldStateArr: string[] = ["I", "DI", "T", "MT", "MH", "C", "TOC"];
            return {
                ...prevState,
                selectedRows: selecedRows,
                forceRefresh: !prevState.forceRefresh,
                accResumeTerminalEnable: !_.isEmpty(selecedRows) && !selecedRows?.some(e => !!!e.dtlState || disableAccTmlResumeStateArr.includes(e.dtlState)),
                holdUnHoldEnable: !_.isEmpty(selecedRows) && !selecedRows?.some(e => !!!e.dtlState || disableHoldUnHoldStateArr.includes(e.dtlState)),
            }
        })
    }

    const onRowDoubleClick = async (row: TransferOfChargeEntity) => {
        transferOfChargeDispatch(prevState => {

            return {
                ...prevState,
                isShowEditPanel: true,
                currentRow: row,
            }
        })
    }

    const onSearchClick = async () => {
        transferOfChargeDispatch(prevState => {

            return {
                ...prevState,
                isShowSearchPanel: !prevState.isShowSearchPanel,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {},
                }
            }
        })
    }

    const onEditClick = async (isEditClick: boolean, isUptBillTo: boolean, isUptChargeOn: boolean, isUptExciseCashNo: boolean, isUptPaidThroughDate: boolean, ids: number[]) => {
        transferOfChargeDispatch(prevState => {
            return {
                ...prevState,
                isShowEditPanel: true,
                isUptExciseCashNo: isUptExciseCashNo,
                isUptPaidThroughDate: isUptPaidThroughDate,
                isEditClick: isEditClick,
                isUptBillTo: isUptBillTo,
                isUptChargeOn: isUptChargeOn,
                buikEditCriteria: {
                    ...EMPTY_TRANSFER_OF_CHARGE_BULK_EDIT_CRITERIA,
                    ids: ids
                },
            }
        })
    }

    const onCloseEidtPanel = async () => {
        transferOfChargeDispatch(prevState => {
            return {
                ...prevState,
                isShowEditPanel: false,
                isUptBillTo: false,
                isUptChargeOn: false,
                isUptExciseCashNo: false,
                isUptPaidThroughDate: false,
                isEditClick: false,
                isUpdateAccTmlReasonCode: false,
                buikEditCriteria: { ...EMPTY_TRANSFER_OF_CHARGE_BULK_EDIT_CRITERIA },
            }
        })
    }

    const onSearchCriteriaResetClick = async () => {
        transferOfChargeDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: { ...EMPTY_TRANSFER_OF_CHARGE_SEARCH_CRITERIA },
            }
        })
    }

    const onSearch = async (searchCriteria: TransferOfChargeSearchCriteria) => {
        transferOfChargeDispatch(prevState => {
            return {
                ...prevState,
                // transferOfChargeList: [],
                searchCriteria: searchCriteria,
                isAdd: false,
                isEdit: false,
                isShowEditPanel: false,
                isUptBillTo: false,
                isUptChargeOn: false,
                isUptExciseCashNo: false,
                isUptPaidThroughDate: false,
                isEditClick: false,
                isUpdateAccTmlReasonCode: false,
                accResumeTerminalEnable: false,
                holdUnHoldEnable: false,
            }
        })
        let msg = '';
        await transferOfChargeRepo.getEntities(searchCriteria).then((data) => {
            if (data.success) {
                transferOfChargeDispatch(prevState => {
                    return {
                        ...prevState,
                        transferOfChargeList: data.data,
                    }
                })
            } else {
                msg = data.data ?? "Search Record Error!";
            }

        }).catch((error) => {
            return error;
        })
        return msg;
    }

    const onSearchFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (fieldKey === 'chargeType') {
            transferOfChargeDispatch(prevState => {
                return {
                    ...prevState,
                    searchCriteria: {
                        ...prevState.searchCriteria,
                        subChargeType: val === prevState.searchCriteria.chargeType ? prevState.searchCriteria.subChargeType : ''
                    },
                }
            })
        }
        if (fieldKey === 'serviceRequestCode') {
            transferOfChargeDispatch(prevState => {
                return {
                    ...prevState,
                    searchCriteria: {
                        ...prevState.searchCriteria,
                        subServiceRequestCode: val === prevState.searchCriteria.serviceRequestCode ? prevState.searchCriteria.subServiceRequestCode : ''
                    },
                }
            })
        }
        if (fieldKey === 'soNumber1' || fieldKey === 'blNo1' || fieldKey === 'serviceReferenceNo'/* || fieldKey === 'agentCode'*/) {
            val = val.toUpperCase();
        }
        transferOfChargeDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldKey]: val,
                },
                masterState: {
                    ...prevState.masterState,
                    allFormState: (fieldKey === 'soNumber1' || fieldKey === 'blNo1') && val === "" ? prevState.masterState.allFormState : {},
                }
            }
        })
    }
    const onEditFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        transferOfChargeDispatch(prevState => {
            return {
                ...prevState,
                buikEditCriteria: {
                    ...prevState.buikEditCriteria,
                    [fieldKey]: val,
                },
            }
        })
    }

    const onDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        transferOfChargeDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [dateFields.startField]: startDate,
                [dateFields.endField]: endDate,
            }
        }))
    }

    const onFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        transferOfChargeDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldKey]: val,
                },
            }
        })
    }

    const onSearchCoVslVoyChange = (inputData: { co?: string, vsl?: string, voy?: string }, fieldName: { co: string, vsl: string, voy: string }) => {
        let coVal: string = "";
        let vslVal: string = "";
        let voyVal: string = "";
        if (inputData?.co) {
            coVal = inputData?.co.toUpperCase().replace(/\s+/g, '');
        }
        if (inputData?.vsl) {
            vslVal = inputData?.vsl.toUpperCase().replace(/\s+/g, '');
        }
        if (inputData?.voy) {
            voyVal = inputData?.voy.toUpperCase();
        }

        transferOfChargeDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [fieldName.co]: coVal,
                [fieldName.vsl]: vslVal,
                [fieldName.voy]: voyVal,
            }
        }))
    }

    const onTextAreaChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue?.toString().toUpperCase();
        const cntrNoArray = val?.split('\n');

        transferOfChargeDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [fieldKey]: fieldKey === 'cntrNos' ? cntrNoArray : val,
            },
            masterState: {
                ...prevState.masterState,
                allFormState: val === "" ? prevState.masterState.allFormState : {},
            }
        }))
    };

    const onSave = async (criteria: TransferOfChargeBulkEditCriteria) => {
        return await transferOfChargeRepo.onSave(criteria);
    }

    const onConfirmAndSubmit = async (ids: number[]) => {
        return await transferOfChargeRepo.onConfirmAndSubmit(ids);
    }

    const onApply = async (ids: number[]) => {
        return await transferOfChargeRepo.onApply(ids);
    }

    const setIsSearchLoading = (isSearchLoading: boolean) => {
        transferOfChargeDispatch(prevState => {
            return {
                ...prevState,
                isSearchLoading: isSearchLoading,
            }
        })
    }

    const showAccTmlReasonCodePanel = async (ids: number[]) => {
        transferOfChargeDispatch(prevState => {
            return {
                ...prevState,
                isShowEditPanel: true,
                isUpdateAccTmlReasonCode: true,
                buikEditCriteria: {
                    ...EMPTY_TRANSFER_OF_CHARGE_BULK_EDIT_CRITERIA,
                    accTmlResume: true,
                    ids: ids
                },
            }
        })
    }

    const onAccTmlResume = async (criteria: TransferOfChargeBulkEditCriteria) => {
        return await transferOfChargeRepo.onSave(criteria);
    }

    const onHoldUnHold = async (criteria: TransferOfChargeBulkEditCriteria) => {
        return await transferOfChargeRepo.onSave(criteria);
    }

    const checkBookingChargeCntr = async (ids: number[]) => {
        return await counterCustomerChargeRepo.checkBookingChargeCntrWithNgen(ids);
    }

    const validateSearchCriteria = async (operatingUnit: string, searchCriteria: TransferOfChargeSearchCriteria) => {
        const valResult = await Validation((operatingUnit === 'SAPT' || operatingUnit === 'KICT'/* || operatingUnit === 'OICT'*/) ? SaptTransferOfChargeSearchCriteriaValidationSchema : transferOfChargeSearchCriteriaValidationSchema).ValidateFormOnly(searchCriteria);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            transferOfChargeDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            return false;

        }
        return true;
    }
    const onSearchButtonClicked = () => {
        transferOfChargeDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }
    return {
        onApply: onApply,
        onConfirmAndSubmit: onConfirmAndSubmit,
        onSave: onSave,
        onEditFieldChange: onEditFieldChange,
        onTextAreaChange: onTextAreaChange,
        onSearchCoVslVoyChange: onSearchCoVslVoyChange,
        onFieldChange: onFieldChange,
        onCloseEidtPanel: onCloseEidtPanel,
        onDateRangeChange: onDateRangeChange,
        onSearchFieldChange: onSearchFieldChange,
        onSearchCriteriaResetClick: onSearchCriteriaResetClick,
        onSearch: onSearch,
        onSearchClick: onSearchClick,
        onEditClick: onEditClick,
        onRowDoubleClick: onRowDoubleClick,
        updateSelectedRows: updateSelectedRows,
        loadDropdownOption: loadDropdownOption,
        setIsSearchLoading: setIsSearchLoading,
        showAccTmlReasonCodePanel: showAccTmlReasonCodePanel,
        onAccTmlResume: onAccTmlResume,
        onHoldUnHold: onHoldUnHold,
        checkBookingChargeCntr: checkBookingChargeCntr,
        validateSearchCriteria: validateSearchCriteria,
        onSearchButtonClicked
    }
}